module.exports = __webpack_public_path__ + "img/1488545939.43ece139.jpg";